import { Stack, Rating, TextField, Typography, Alert } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import { useState, useEffect } from "react";
import Toast from "../../Tools/Toast";
import API from "../../../services/API";
import Loader from '../../Tools/Loader';
import { txt } from "../../../services/translation";

export default function Review({course}){

    const [toast, setToast] = useState(false)

    const [review, setReview] = useState(null);

    const [status, setStatus] = useState('ready')

    const statusIs = s => s === status

    useEffect(() => {

        API.get(`/study/courses/${course.id}/review`)
            .then(r => setReview(r.data))
            .catch(e => setReview({
                    rating: 0,
                    comment: '',
                    publishable: true,
                    course: {id: course.id}
                })
            )

    }, [course])


    const handleSubmit = e => {
        e.preventDefault();

        if(!isValid()) return setStatus('invalid');

        (review.id ? 
            API.put(`/study/reviews/${review.id}`, review) : 
            API.post(`/study/reviews`, review)
        )
            .then(r => handleSuccess(r))
            .catch(e => handleError())
        
        return setStatus('submit');
    }


    const handleSuccess = r => {
        if (r.data) setReview(r.data);
        setStatus('ready');
        return setToast(['success', txt('reviewSuccessMessage')]);
    }
      
    const handleError = () => {
        setStatus('ready');
        return setToast(['error', txt('reviewErrorMessage')]);
    }

    const isValid = () => (review.rating || 0) > 0 
        && (review.comment || '').length > 0


    if(!review) return <Loader />


    return review && <Stack direction='row' justifyContent='center' sx={{mt: 1}}>

        <form onSubmit={handleSubmit}>

            <Stack spacing={3} width={window.innerWidth < 800 ? 320 : 500}>

                {statusIs('invalid') &&
                    <Alert severity='error'>{txt('invalidRatingMessage')}</Alert>
                }

                <Stack direction='row' spacing={2} alignItems='center' flexWrap='wrap'>

                    <Typography>{txt('yourRatingLabel')}</Typography>

                    <Rating 
                        label={txt('yourRatingLabel')}
                        value={review.rating}
                        onChange={(e,v) => setReview({...review, rating: v})}
                        size='large'
                    />

                </Stack>

                <TextField
                    label={txt('yourReviewLabel')}
                    value={review.comment || ''}
                    onChange={e => setReview({...review, comment: e.target.value})}
                    inputProps={{
                        minLength: 3,
                        maxLength: 500
                    }}
                    required={true}
                    multiline
                    minRows={3}
                />
                

                {true && <>

                    <Typography>{txt('suggestionsQuestion')}</Typography>

                    <TextField
                        label={txt('yourSuggestionsLabel')}
                        value={review.proposal || ''}
                        onChange={e => setReview({...review, proposal: e.target.value})}
                        inputProps={{
                            maxLength: 255
                        }}
                    />

                </>}

                    
                <LoadingButton 
                    variant='contained'
                    type='submit'
                    loading={statusIs('submit')}
                    disabled={!isValid()}
                >
                    {txt('save')}
                </LoadingButton>

            </Stack>

        </form>

        <Toast
            open={toast ? true : false}
            severity={toast[0]}
            message={toast[1]}
            onClose={() => setToast(false)}
        />

    </Stack>
}

